import { render, staticRenderFns } from "./FL-SL-Disclosure.vue?vue&type=template&id=0dc892d3&scoped=true&"
import script from "./FL-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./FL-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./FL-SL-Disclosure.vue?vue&type=style&index=0&id=0dc892d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc892d3",
  null
  
)

export default component.exports